import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'

interface ExtraItem {
  heading: string
  position: number
  id: string
}

export interface Options {
  disabled?: boolean
}

function useOfferListExtras(filters: App.OfferListFilters | undefined, options: Options = {}): Array<ExtraItem> {
  const { disabled = false } = options
  const intl = useIntl()

  const listKey = useMemo(() => filters ? getOfferListKey(filters) : '', [filters])

  const extras = useAppSelector(state => state.offer.offerLists[listKey]?.extras ?? [])

  return useMemo(() => {
    if (disabled) {
      return []
    }
    return extras.map((extra): ExtraItem | undefined => {
      switch (extra.type) {
        case 'nearby':
          return {
            id: 'nearby-offers',
            heading: intl.formatMessage({
              id: '9715mYOIVLVc27KDMrkJ',
              defaultMessage: 'Nearby offers',
              description: 'Section heading for nearby offer recommendations on offer list page',
            }),
            position: extra.position,
          }
        case 'you-may-also-like':
          return {
            id: 'you-may-also-like',
            heading: intl.formatMessage({
              id: 'MnlUrXdosMs1ilDV6KEJ',
              defaultMessage: 'You may also like',
              description: 'Section heading for similar offer recommendations on offer list page',
            }),
            position: extra.position,
          }
        case 'second-tier-available':
          return {
            id: 'second-tier-available',
            heading: intl.formatMessage({
              id: '8iBkEHMfAx0oO1PCuwoz',
              defaultMessage: 'We couldn’t find any other offer within your requested price range. Here are other available options.',
              description: 'Section heading above out-of-budget search offers after in-range results',
            }),
            position: extra.position,
          }
        default:
          return undefined
      }
    }).filter((item): item is ExtraItem => item !== undefined)
  }, [disabled, extras, intl])
}

export default useOfferListExtras
